import React from 'react';
import PropTypes from 'prop-types';

import './CategoryProductList.sass';

import {connect} from 'react-redux';
import { fetchTaxonProductsBySlug, fetchTaxonProductsBySlugPosition } from '../../../ducks/taxons';
import {isMainTaxon} from '../../../utils/taxons';

import Loader from '../../../components/loader/Loader';
import SpecialProductList from '../../../components/specialProductList/SpecialProductList';
import Products from '../../../components/products/Products';

import {FormattedMessage} from 'react-intl';
import {
  analyticsClearEcommerce,
  analyticsViewItemList, analyticsViewLimitedItemList, analyticsViewSpecialItemList,
} from '../../../middlewares/analytics/actions';

@connect(({taxons}, {taxon}) => ({
  products: isMainTaxon(taxon) ? taxons.products.popular[taxon.slug] : taxons.products.all[taxon.slug],
  limitedProducts: taxons.products.limited[taxon.slug]
}))
export default class CategoryProductList extends React.PureComponent {
  static fetchData = ({ dispatch, taxon, products, limitedProducts }) =>
    Promise.all([
      limitedProducts === undefined && dispatch(fetchTaxonProductsBySlug("limited", taxon.slug, -1)),
      isMainTaxon(taxon)
        ? products === undefined && dispatch(fetchTaxonProductsBySlugPosition("popular", taxon.slug, 1))
        : products === undefined && dispatch(fetchTaxonProductsBySlugPosition("all", taxon.slug, -1)),
    ]);

  componentDidMount() {
    CategoryProductList.fetchData(this.props);

    const {taxon, limitedProducts, products, dispatch} = this.props;

    if (taxon && limitedProducts && !!limitedProducts.items.length && !limitedProducts.isLoading) {
      dispatch(analyticsClearEcommerce());
      dispatch(analyticsViewLimitedItemList(taxon, limitedProducts.items));
    }

    if (taxon && products && !products.isLoading) {
      dispatch(analyticsClearEcommerce());

      if (isMainTaxon(taxon)) {
        dispatch(analyticsViewSpecialItemList(taxon, products.items));
      } else {
        dispatch(analyticsViewItemList(taxon, products.items));
      }
    }
  }

  componentDidUpdate() {
    CategoryProductList.fetchData(this.props);

    const {taxon, limitedProducts, products, dispatch} = this.props;

    if (taxon && limitedProducts && !!limitedProducts.items.length && !limitedProducts.isLoading) {
      dispatch(analyticsClearEcommerce());
      dispatch(analyticsViewLimitedItemList(taxon, limitedProducts.items));
    }

    if (taxon && products && !products.isLoading) {
      dispatch(analyticsClearEcommerce());

      if (isMainTaxon(taxon)) {
        dispatch(analyticsViewSpecialItemList(taxon, products.items));
      } else {
        dispatch(analyticsViewItemList(taxon, products.items));
      }
    }
  }

  render() {
    const {limitedProducts, products, taxon} = this.props;

    if (!limitedProducts || limitedProducts.isLoading || !products || products.isLoading) {
      return <Loader row/>;
    }

    return (
      <div className="category-products">
        {!!limitedProducts.items.length && (
          <div className="category-products__section">
            <h2 className="category-products__section-header">
              <FormattedMessage id="page.category.limited"/>
            </h2>

            <SpecialProductList taxon={taxon} products={limitedProducts.items}/>
          </div>
        )}

        <div className="category-products__section">
          {isMainTaxon(taxon) && (
            <h2 className="category-products__section-header">
              <FormattedMessage id="page.category.special"/>
            </h2>
          )}

          <Products
            three
            taxon={taxon}
            isMainTaxon={isMainTaxon(taxon)}
            products={products.items}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/categoryPage/categoryProductList/CategoryProductList.js